"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createJwtTokenProvider = createJwtTokenProvider;
exports.getSuggestions = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _urlJwtConvertor = require("@airasia-common/url-jwt-convertor");

var _constant = require("./constant");

var _util = require("./util");

function createJwtTokenProvider() {
  var tokens = {};

  var getToken = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(config) {
      var endpoint,
          tokenConvertor,
          token,
          _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              endpoint = _args.length > 1 && _args[1] !== undefined ? _args[1] : _constant.DEFAULT_ENDPOINT;

              if (!tokens[endpoint]) {
                _context.next = 5;
                break;
              }

              _context.next = 4;
              return tokens[endpoint].getToken(endpoint);

            case 4:
              return _context.abrupt("return", _context.sent);

            case 5:
              tokenConvertor = new _urlJwtConvertor.UrlToJWT(config.ssr_url, _constant.JWT_HASH, _constant.SSR_DATA);
              _context.next = 8;
              return tokenConvertor.getToken(endpoint);

            case 8:
              token = _context.sent;
              tokens[endpoint] = tokenConvertor;
              return _context.abrupt("return", token);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getToken(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return getToken;
}

var fetchToken = createJwtTokenProvider();

var getSuggestions = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(searchTerm, config, locale, isOnlySuggestion) {
    var placepickerConfig, jwtToken, headers, url, resp, suggestions;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            placepickerConfig = config.placePickerConfig;
            _context2.next = 3;
            return fetchToken(placepickerConfig, 'smartfill');

          case 3:
            jwtToken = _context2.sent;
            headers = {
              'Client-ID': placepickerConfig.client_id,
              authorization: "Bearer ".concat(jwtToken)
            };

            if (isOnlySuggestion) {
              url = (0, _util.urlFormatter)(placepickerConfig.suggestion_url, ["".concat(searchTerm), locale]);
            } else {
              url = (0, _util.urlFormatter)(placepickerConfig.suggestions_url, [locale, "".concat(searchTerm)]);
            } // const url = urlFormatter(placepickerConfig.suggestions_url, [locale, `${searchTerm}`]);


            _context2.next = 8;
            return fetch(url, {
              headers: headers
            });

          case 8:
            resp = _context2.sent;
            _context2.next = 11;
            return resp.json();

          case 11:
            suggestions = _context2.sent;
            return _context2.abrupt("return", suggestions);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getSuggestions(_x2, _x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getSuggestions = getSuggestions;